import Vue from "vue";
import {makeRoute} from '$src/lib/helper';
import store from "$src/store";

export default {
    routes: [{
        path: '/backend',
        meta: {isAuth: true, hasRight: 'access_backend'},
        component: () => import(/* webpackChunkName: "backend" */ '$backend/layouts/BackendLayout'),
        children: [
            {
                path: '',
                beforeEnter(to, from, next) {
                    if (from && from.name && from.name.startsWith('community')) {
                        store.commit('routing/setLastRouteCommunity', from.path);
                        let lastBackend = store.getters['routing/lastRouteBackend'];
                        if (to && to.path && lastBackend && to.path != lastBackend) {
                            return next({path: lastBackend});
                        }
                    }
                    if (Vue.$env.isApplication) {
                        return next({name: 'backend_applications_overview'});
                    }
                    next({name: 'backend_students_overview'});
                },
                name: 'backend_home',
            },

            makeRoute('applications', 'backend_applications_overview', () => import(/* webpackChunkName: "backend" */ '$backend/views/ApplicationsOverview'), {
                title: 'Bewerbungen',
                hasRight: 'access_backend_applications',
            }),

            makeRoute('students', 'backend_students_overview', () => import(/* webpackChunkName: "backend" */ '$backend/views/StudentsOverview'), {
                title: 'Stipendiaten',
                hasRight: 'access_backend_students',
            }),

            makeRoute('interviews', 'backend_interview_overview', () => import(/* webpackChunkName: "backend" */ '$backend/views/InterviewOverview'), {
                title: 'Terminübersicht',
                hasRight: 'access_backend_interviews',
                action: 'interview/fetchList',
            }),

            makeRoute('locations', 'backend_location_overview', () => import(/* webpackChunkName: "backend" */ '$backend/views/InterviewLocationOverview'), {
                title: 'Terminorte verwalten',
                hasRight: 'access_backend_interview_locations',
                action: 'interviewLocation/fetchList',
            }),

            makeRoute('/locations/:id_interview_location', 'backend_location', () => import(/* webpackChunkName: "backend" */ '$backend/views/InterviewLocationView'), {
                title: 'Terminort',
                hasRight: 'access_backend_interview_locations',
                action: 'interviewLocation/fetchLocation',
            }),

            makeRoute('users', 'backend_user_overview', () => import(/* webpackChunkName: "backend" */ '$backend/views/UserOverview'), {
                title: 'Benutzer verwalten',
                hasRight: 'access_backend_users',
            }),

            makeRoute('texts', 'backend_texts', () => import(/* webpackChunkName: "backend" */ '$backend/views/TextsView'), {
                title: 'Texte verwalten',
                hasRight: 'access_backend_texts',
                action: 'texts/fetchList',
            }),

            makeRoute('settings', 'backend_settings', () => import(/* webpackChunkName: "backend" */ '$backend/views/SettingsView'), {
                title: 'Einstellungen',
                hasRight: 'access_backend_settings',
                action: 'settings/fetchConfig',
            }),
            makeRoute('partners', 'backend_partner_overview', () => import(/* webpackChunkName: "backend" */ '$backend/views/PartnerOverview'), {
                title: 'Partner Verwalten',
                hasRight: 'access_backend_partner',
            }),
            makeRoute('partner/:id_partner/:section', 'backend_partner_view', () => import(/* webpackChunkName: "backend" */ '$backend/views/PartnerView'), {
                title: 'Partner bearbeiten',
                action: 'backend/fetchPartner',
                hasRight: 'access_backend_partner',
            }),
            makeRoute('news', 'backend_news_overview', () => import(/* webpackChunkName: "backend" */ '$backend/views/NewsOverview'), {
                title: 'News verwalten',
                hasRight: 'access_backend_news',
            }),
            makeRoute('post/:id_post', 'backend_post_view', () => import(/* webpackChunkName: "backend" */ '$backend/views/PostEditView'), {
                title: 'Beitrag bearbeiten',
                action: 'backend/fetchPost',
                hasRight: 'access_backend_news',
            }),
            makeRoute('tasks', 'backend_tasks_view', () => import(/* webpackChunkName: "backend" */ '$backend/views/TasksOverview'), {
                title: 'Aufgabenmanagement',
                hasRight: 'access_backend_tasks',
            }),
            makeRoute('dashboard/team', 'backend_team_dashboard', () => import(/* webpackChunkName: "backend" */ '$backend/views/TeamDashboardView'), {
                title: 'Team Dashboard',
                hasRight: 'access_backend_team_dashboard',
            }),
            makeRoute('dashboard/controlling', 'backend_controlling_dashboard', () => import(/* webpackChunkName: "backend" */ '$backend/views/ControllingDashboardView'), {
                title: 'Controlling Dashboard',
                hasRight: 'access_backend_controlling_dashboard',
            }),
            makeRoute('event-series/overview', 'backend_event_series_overview', () => import(/* webpackChunkName: "backend" */ '$backend/views/EventSeriesOverview'), {
                title: 'Terminreihen-Assistent',
                action: 'backend/fetchEventSeriesList',
                hasRight: 'access_backend_event_series',
            }),
            makeRoute('event-series/:id_event_series', 'backend_event_series_view', () => import(/* webpackChunkName: "backend" */ '$backend/views/EventSeriesView'), {
                title: 'Terminreihe Verwalten',
                action: 'backend/fetchEventSeries',
            }),
            makeRoute('seminar-assistant', 'backend_seminar_assistant', () => import(/* webpackChunkName: "backend" */ '$backend/views/SeminarAssistant'), {
                title: 'Bildungsseminar erstellen',
            }),
            makeRoute('statistics', 'backend_statistics_view', () => import(/* webpackChunkName: "backend" */ '$backend/views/StatisticsView'), {
                title: 'Statistiken',
            }),
            makeRoute('/survey', 'backend_survey_overview', () => import(/* webpackChunkName: "backend" */ '$backend/views/SurveyOverview'), {
                title: 'Umfragen verwalten',
                action: 'backend/fetchSurveyList',
                hasRight: 'access_backend_surveys',
            }),
            makeRoute('survey/:id_survey', 'backend_survey_view', () => import(/* webpackChunkName: "backend" */ '$backend/views/SurveyView'), {
               title: 'Umfrage',
               action: 'backend/fetchSurvey',
               hasRight: 'access_backend_surveys',
            }),
        ],
    }],

    hooks: {
        async initialize() {
            await Promise.all([
                import(/* webpackChunkName: "backend" */ '$backend/modals'),
                import(/* webpackChunkName: "backend" */ '$backend/components'),
                import(/* webpackChunkName: "backend" */ '$backend/components/actions'),
                import(/* webpackChunkName: "backend" */ '$src/components/filter'),
                import(/* webpackChunkName: "backend" */ '$src/components/form'),
                import(/* webpackChunkName: "backend" */ '$backend/modules'),
            ]);
        },
        beforeEnter() {
            this.$ui.titleTemplate = '%s - START Backend';
            this.$ui.defaultTitle = 'START Stiftung Backend';
        },
    },
};